import React, { FC, useState, useEffect, FocusEvent } from 'react'
import { Box, List, ListItem, IconButton, Grid, Button, CircularProgress } from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete'
import { SimpleTextField } from 'src/components/ui'
import { useEditStagingGatewaysRequest } from 'src/hooks/api'
import { useAddPopupMessage } from 'src/hooks/ui'

interface EditableStagingGatewaysProps {
  stagingGateways: string[]
  onChange: () => void
  onCancel: () => void
}

export const EditableStagingGateways: FC<EditableStagingGatewaysProps> = (props) => {
  const { stagingGateways, onCancel, onChange } = props
  const [deviceIds, setDeviceIds] = useState<string[]>([])
  const [newDeviceId, setNewDeviceId] = useState<string>('')
  const editStagingGatewaysRequest = useEditStagingGatewaysRequest()
  const addMessage = useAddPopupMessage()

  useEffect(() => {
    setDeviceIds(stagingGateways)
  }, [stagingGateways])

  const onDelete = (deviceId: string) => {
    setDeviceIds(deviceIds.filter((item) => item !== deviceId))
  }

  const addNewDeviceId = () => {
    setDeviceIds([...deviceIds, newDeviceId])
    setNewDeviceId('')
  }

  const onBlurDeviceId = (event: FocusEvent<HTMLInputElement>, index: number) => {
    const { value } = event.target
    const copy = [...deviceIds]
    copy[index] = value
    setDeviceIds(copy)
  }

  const saveStagingGateways = () => {
    editStagingGatewaysRequest.mutate(
      {
        stagingGateways: deviceIds
      },
      {
        onSuccess: () => {
          addMessage({ text: 'List of staging gateways successfully saved', type: 'success' })
          onChange()
        },
        onError: (error) => {
          addMessage({ text: error.message, type: 'error' })
        }
      }
    )
  }

  return (
    <Box>
      <Grid container spacing={2} direction="column">
        <Grid item>
          <List dense>
            {deviceIds.map((deviceId, index) => (
              <ListItem
                key={deviceId}
                secondaryAction={
                  <IconButton edge="end" aria-label="delete" onClick={() => onDelete(deviceId)}>
                    <DeleteIcon />
                  </IconButton>
                }
              >
                <SimpleTextField value={deviceId} label="Device ID" required TextFieldProps={{ placeholder: 'Device ID' }} onBlur={(event) => onBlurDeviceId(event, index)} />
              </ListItem>
            ))}
          </List>
        </Grid>
        <Grid container item spacing={2} alignItems="center">
          <Grid item flexGrow={1}>
            <SimpleTextField value={newDeviceId} label="Device ID" TextFieldProps={{ placeholder: 'Add new Staging gateway Device ID' }} onChange={(event) => setNewDeviceId(event.target.value)} />
          </Grid>
          <Grid item>
            <Button variant="outlined" onClick={addNewDeviceId}>
              Add
            </Button>
          </Grid>
        </Grid>
        <Grid item flexShrink={0}>
          <Grid container spacing={1}>
            <Grid item>
              <Box pt={2}>
                <Button variant="contained" color="primary" type="submit" disabled={editStagingGatewaysRequest.isLoading} onClick={saveStagingGateways}>
                  {editStagingGatewaysRequest.isLoading ? <CircularProgress color="info" size={26} /> : 'Save'}
                </Button>
              </Box>
            </Grid>
            {onCancel && (
              <Grid item>
                <Box pt={2}>
                  <Button variant="outlined" onClick={onCancel}>
                    Cancel
                  </Button>
                </Box>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
    </Box>
  )
}
